<template>
  <div class="home">
    <tool-bar/>
    <div v-if="$store.state.loading.foregroundLoading > 0">
      <loading-bar/>
    </div>

    <router-view v-if="$store.state.dailyCounts.statusCode === 200"/>
    <div v-else>
      <div v-if="$store.state.dailyCounts.statusCode === 404">
        Latest daily report not found...
      </div>
      <div v-if="$store.state.dailyCounts.statusCode === 500">
        Something went wrong...
      </div>
    </div>
  </div>
</template>

<script>
import ToolBar from "@/components/ToolBar";
import LoadingBar from "../components/LoadingBar";

export default {
  name: 'Home',
  components: {
    LoadingBar,
    ToolBar
  },
  mounted() {
    this.$store.dispatch('getDailyCounts', {brand: null});
  }
}
</script>

<style lang="scss" scoped>
  .home {
    width: 100% !important;
    position: absolute;
  }
</style>
